import React from "react";

export const Footer=()=>{
    return (
        <footer className="footer" style={{position:'fixed'}}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6">
                       {/* new Date().getFullYear()} &copy; Created by <a href="/">DRI-O Team</a> */}
                       RAINSCALES ©{new Date().getFullYear()} Made by DRI Team
                    </div>
                    <div className="col-md-6">
                        <div className="text-md-end footer-links d-none d-sm-block">
                            <a href="https://hr.rainscales.com.vn">Backoffice RAINSCALES</a> Version 2.1.5
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}